export default "__VITE_ASSET__BjE8XZbo__"